/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getDetailListadoPagoConsulta } from "../../Api";
import { dateToLocaleYears, formatCurrency } from '../../Functions'

const TableDetailConsulta = ({fechaproceso}) => {

  const [state, setState] = useState({
    data: [],
    loading: true
  });

  const loadData = async () => {
    const _response = await getDetailListadoPagoConsulta({ fecha: dateToLocaleYears(fechaproceso) });
    if (_response.status) {
      setState({
        data: _response.data.records,
        loading: false,
      });
    }
  }

  useEffect(() => {
    loadData();
  }, [fechaproceso])

  return (
    <>
      <div className="row">
        <div className={`col-12 table-responsive ${state.loading ? 'table-loading-overlay' : ''}`} style={{height: '400px'}}>
          <table className="table table-bordered table-payment-detailtype">
            <thead className="text-white">
              <tr>
                <th> N° Ingreso</th>
                <th> Nombre Paciente</th>
                <th> Fecha Atención.</th>
                <th> Isapre </th>
                <th> Origen </th>
                <th> Código Prestación </th>
                <th> Nombre Prestación </th>
                <th> Monto Prestación </th>
              </tr>
            </thead>
            <tbody className="text-gray-800">
              {state?.data?.map((item, index) => (
                <tr key={index}>
                  <td> { item.rolclinica } </td>
                  <td> { item.paciente } </td>
                  <td> { item.fechaingreso } </td>
                  <td> { item.nombre } </td>
                  <td> { item.origen } </td>
                  <td> { item.codigoprestacion } </td>
                  <td> { item.nombreprestacion } </td>
                  <td> { formatCurrency(item.montoprestacion) } </td>
              </tr>))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default TableDetailConsulta